import React from 'react';
import {connect} from 'react-redux';
import {ThunkDispatch} from 'redux-thunk';
import {AnyAction} from 'redux';
import difference from 'lodash/difference';
import {toast} from 'react-toastify';

import {CategoryService} from '../Services/CategoryService';
import {setCategories} from '../Store/Home/Actions';
import {AppState} from '../Store';

import CategoryEditor from './CategoryEditor';

interface CategoriesProps {
  categoryService: CategoryService;
  categories: string[];

  setCategories: (categories: string[]) => void;
}

function Categories({categories, categoryService, setCategories}: CategoriesProps) {
  const categoriesChanged = async (newCategories: string[]) => {
    const added = difference(newCategories, categories);
    const removed = difference(categories, newCategories);

    for (const cat of added) {
      try {
        await categoryService.create(cat);
        toast.success(`Added category ${cat}`);
      } catch (e) {
        console.log(e);
        toast.error('Failed to add category');
      }
    }

    for (const cat of removed) {
      try {
        await categoryService.remove(cat);
        toast.success(`Removed category ${cat}`);
      } catch (e) {
        console.log(e);
        toast.error('Failed to add category');
      }
    }

    try {
      const apiCategories = await categoryService.list();
      if (apiCategories.parsedBody !== undefined) {
        newCategories = apiCategories.parsedBody;
      }
    } catch (e) {
      toast.error(e);
    }

    setCategories(newCategories);
  };

  return (
    <CategoryEditor categories={categories} onChange={categoriesChanged} />
  );
}

const mapStateToProps = (state: AppState) => {
  return {
    categoryService: state.auth.categoryService,
    categories: state.home.categories,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    setCategories: (categories: string[]) => dispatch(setCategories(categories)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Categories);
